document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".snowflake").forEach(flake => {
    flake.style.left = Math.random() * 100 + "%";
    flake.style.animationDuration = 4 + Math.random() * 6 + "s";
    flake.style.animationDelay = Math.random() * 5 + "s";
    flake.style.transform = `scale(${Math.random()})`;
  });
});